import {inject, Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import {chatbubbleOutline, checkmark, close} from 'ionicons/icons';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly toastController = inject(ToastController);

  constructor() {
    addIcons({close, chatbubbleOutline, checkmark});
  }

  async showMessageToast(message: string) {
    const toast = await this.toastController.create({
      animated: true,
      message: message,
      translucent: true,
      duration: 5000,
      position: 'bottom',
      color: 'dark',
      icon: 'chatbubble-outline',
      cssClass: 'custom-toast-message',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel'
        }
      ]
    });

    toast.present();
  }

  async showToast(message: string) {
    const toast = await this.toastController.create({
      animated: true,
      message: message,
      translucent: true,
      duration: 5000,
      position: 'top',
      color: 'dark',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel'
        }
      ]
    });

    toast.present();
  }

  async showToastSuccess(
    message: string,
    icon: string,
    duration: number,
    css: string
  ) {
    const toast = await this.toastController.create({
      animated: true,
      message: message,
      translucent: true,
      duration: duration || 5000,
      position: 'top',
      color: 'success',
      icon: icon || 'checkmark',
      cssClass: css || '',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }

  async showToastError(message: string, duration: number = 15000) {
    const toast = await this.toastController.create({
      animated: true,
      message: message,
      translucent: true,
      duration,
      position: 'top',
      color: 'danger',
      // icon: 'close',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel'
        }
      ]
    });

    toast.present();
  }

  async showToastWarning(message: string) {
    const toast = await this.toastController.create({
      animated: true,
      message: message,
      translucent: true,
      duration: 5000,
      position: 'bottom',
      color: 'warning',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel'
        }
      ]
    });

    toast.present();
  }
}
